import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-blue-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <rect x="4" y="14" width="5" height="6" fill={textColor} />
    <rect x="9" y="9" width="5" height="11" fill={textColor} />
    <rect x="14" y="4" width="6" height="16" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <rect x="18.7202" y="8" width="5.44" height="16" fill={textColor} />
    <rect x="13.28" y="13.4399" width="5.44" height="10.56" fill={textColor} />
    <rect x="7.84009" y="18.7202" width="5.44" height="5.28" fill={textColor} />
  </>
);

export const ChoicesIcon = createSlideIcon(Icon24x24, Icon32x32);
